import { useContext } from "react";
import ContextConstructor from "./ContextProvider";
import { IMyMontepioContext } from "./types";

export default function useMyMontepioContext(): IMyMontepioContext {
  return useContext(ContextConstructor) as IMyMontepioContext;
}
